const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, useDots } = window.BAO.Carousel.plugins

class FadingCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        renderMode: 'custom',
        slideChanged: this.onSlideChanged,
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        useDots(this.els?.dot?.elements),
      ],
    )
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.els.slide.elements.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index !== currentSlide)
    })

    if (!this.els?.content?.exists) return

    this.els.content.elements.forEach((slideContent) => {
      slideContent.setAttribute(
        'aria-hidden',
        parseInt(slideContent.dataset.index) !== currentSlide,
      )
    })
  }
}

if (!customElements.get('fading-carousel')) {
  customElements.define('fading-carousel', FadingCarousel)
}
